import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link as LinkRoute } from 'react-router-dom';
import { PopUpContainerDiv, PopUpIcon, LinksContainer, HomeStyledLink, ImageLinkContainer } from '.';
import * as actions from '../../actions';
import { IStore } from '../../interfaces';
import { IScarfInfo, ITrophyTooltip, IDetailTrophyTooltip, EnumSection } from '../../interfaces/clientInterfaces';
import { Localizer } from '../../utils/localizer';
import DetailTrophyTooltip from './DetailTrophyTooltip';
import PopUp from './PopUp';
import ReserveTeamTooltip from './ReserveTeamTooltip';
import TeamInfoRenderer from './TeamInfoRenderer';
import TrophyTooltip from './TrophyTooltip';
import { useAppDispatch } from '../../utils/modules';

export function TeamDetailInfo() {
	const dispatch = useAppDispatch();

	const section = useSelector(
		(completeState: IStore): EnumSection | null => {
			return completeState?.ui?.section ?? null;
		});


	const homeDetailScarfInfo = useSelector(
		(completeState: IStore): IScarfInfo | null => {
			return completeState?.general?.homeDetailScarfInfo ?? null;
		});

	const isMobileViewActive = useSelector(
		(completeState: IStore): boolean => {
			return completeState?.ui?.isMobileViewActive ?? false;
		});

	const trophyTooltip = useSelector(
		(completeState: IStore): ITrophyTooltip | null => {
			return completeState?.ui?.trophyTooltip ?? null;
		});

	const detailTrophyTrophy = useSelector(
		(completeState: IStore): IDetailTrophyTooltip | null => {
			return completeState?.ui?.detailTrophyTooltip ?? null;
		});

	const closeTeamRenderer = useCallback(() => {
		dispatch(actions.setHomeDetailTeam(-1));
	}, [dispatch]);

	const renderTrophyTooltip = useCallback(() => {
		if (!trophyTooltip) {
			return null;
		}
		return (
			<TrophyTooltip
				trophyTooltip={trophyTooltip}
			/>
		);
	}, [trophyTooltip]);


	const renderDetailTrophyTooltip = useCallback(() => {
		if (!detailTrophyTrophy) {
			return null;
		}
		return (
			<DetailTrophyTooltip
				detailTrophyTooltip={detailTrophyTrophy} />
		);
	}, [detailTrophyTrophy]);


	if (!homeDetailScarfInfo) {
		return null;
	}
	const countryName = Localizer.getLocalizedCountryName(homeDetailScarfInfo.team.countryCode);
	return (
		<>
			<PopUp onOverlayClick={closeTeamRenderer}>
				<PopUpContainerDiv isMobileViewForPopUp={isMobileViewActive}>
					<PopUpIcon
						className='fa fa-times'
						onClick={closeTeamRenderer}
					/>
					<TeamInfoRenderer
						scarfInfo={homeDetailScarfInfo}
						isMapInfo={false}
						section={EnumSection.home}
					/>
					<LinksContainer>
						{
							section !== EnumSection.map &&
							<HomeStyledLink isMobileViewActive={isMobileViewActive}>
								<LinkRoute to={`/map?center=${homeDetailScarfInfo.team.name}`}>
									{'See on map'}
								</LinkRoute>
							</HomeStyledLink>
						}
						<HomeStyledLink isMobileViewActive={isMobileViewActive}>
							<ImageLinkContainer src={`../../../img/flag/${homeDetailScarfInfo.team.countryCode}.png`} alt={countryName} />
							<LinkRoute to={`/${countryName}`}>
								{'See Scarves of country'}
							</LinkRoute>
						</HomeStyledLink>
					</LinksContainer>
				</PopUpContainerDiv>
			</PopUp>
			{renderTrophyTooltip()}
			<ReserveTeamTooltip />
			{renderDetailTrophyTooltip()}
		</>
	);
}
